<template>
  <div class="noticePage">
    <!-- <h4>用户协议</h4> -->
    <p>
      <span>1. 特别提示</span>
      1.1为使用本应用软件及服务，您应当阅读并遵守《用户使用协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及同意或使用某项服务的单独协议，并选择接受或不接受。
      <br />1.2 除非您已阅读并接受本协议所有条款，否则您无权使用本软件及相关服务。您的下载、安装、使用、获取账号、登录等行为即视为您已阅读并同意上述协议的约束。
      <br />1.3 东华（安徽）生态规划院有限公司（以下称“本公司”）同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务（以下称"本服务"）。若您需要获得本服务，您（以下称"用户"）应当同意本协议的全部条款并按照页面上的提示完成全部的申请程序。
      <br />

      <span>2. 协议的范围</span>
      2.1 协议适用主体范围
      <br />本协议是用户与本公司之间关于用户下载、安装、使用、复制本软件，以及使用本公司相关服务及业主所订立的协议。
      <br />2.2 协议关系和冲突条款
      <br />>
      本公司在网站上公布的服务条款和本公司与业主单位签订的协议、合同等都是是本协议的补充。本协议与上述内容存在冲突的，以本公司和业主协商的为准。
      <br />
      <span>3.服务内容与授权使用范围</span>
      3.1本软件根据用户实际需求提供服务，例如林长上传下达、考核等。
      <br />3.2本软件应用的授权使用范围：
      <br />1) 用户只现定于本公司和业务单位签订的范围。
      <br />2) 保留权利：未明示授权的其他一切权利均由本公司所有。
      <br />
      <span>4. 使用规则</span>
      4.1账号使用规则
      <br />4.1.1账号由本公司和业主签订的使用范围进行注册，包括总林长、林长、护林员、协同单位及工作人员、责任单位及工作人员。
      <br />4.1.2本软件账号的所有权归本公司所有，用户完成申请注册手续后，仅获得账号的使用权，同时，初始申请注册人不得赠与、借用、租用、转让或售卖账号或者以其他方式许可非初始申请注册人使用账号。
      <br />4.1.3用户承担账号与密码的保管责任，用户对以其账号发生的或通过其账号发生的一切活动和事件（包括但不限于用户发表的任何内容以及由此产生的任何结果）负全部法律责任。用户须重视账号与密码的保护，若因为用户自身原因，而导致账号与密码遭他人非法使用时，本公司将不承担任何责任。用户自身原因包括但不限于：任意向第三者透露账号和密码及所有注册资料；多人共享同一个账号；安装非法或来路不明的程序等。
      <br />4.2用户使用规则
      <br />4.2.1用户在使用本软件时，必须遵循以下原则：
      <br />1) 遵守中国有关的法律和法规；
      <br />2) 不得为任何非法目的而使用本服务系统；
      <br />3) 遵守所有与本服务有关的网络协议、规定和程序；
      <br />4) 不得利用本软件系统进行任何可能对互联网的正常运转造成不利影响的行为；
      <br />5) 不得利用本软件服务系统进行任何不利于其他用户的行为；
      <br />6) 如发现任何非法使用用户账号或账号出现安全漏洞的情况，应立即通告本公司官方；
      <br />7) 不使用外挂或者其他作弊手段、不正当或不公平手段参加本软件提供的本服务。
      <br />8) 不得将用户账号和密码转赠、转借第三方。
      <br />4.2.2本公司致力于为用户提供专业、规范的服务，用户应遵守中华人民共和国相关法律法规(如果用户是中华人民共和国境外的使用者，还应遵守所属国家或地区的法律法规)，用户将自行承担用户所发布的信息内容的责任。特别地，用户不得发布下列内容：
      <br />1) 反对中华人民共和国宪法所确定的基本原则的；
      <br />2) 危害国家统一、主权和领土完整的；
      <br />3) 泄露国家秘密，危害国家安全或者损害国家荣誉和利益的；
      <br />4) 煽动民族仇恨、民族歧视，破坏民族团结或者侵害民族风俗、习惯的；
      <br />5) 破坏国家宗教政策，宣扬邪教、迷信的；
      <br />6) 散布谣言，扰乱社会秩序，破坏社会稳定的；
      <br />7) 散布淫秽、赌博、暴力或者教唆犯罪的；
      <br />8) 侮辱或者诽谤他人，侵害他人合法权益的；
      <br />9) 危害社会公德或者民族优秀文化传统的；
      <br />10) 宣扬外挂,私服以及木马的相关内容；
      <br />11) 刊登任何经本公司合理判断为不妥当或者本公司未认可的软件、文件等在内的主页地址或者链接的行为；
      <br />12) 含有中华人民共和国法律、行政法规禁止的其他内容的。
      <br />
      <span>5. 知识产权</span>
      5.1本公司是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于视频课件、文字、图片、音频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，本公司享有上述知识产权，除非事先经本公司的合法授权，任何人皆不得擅自以任何形式使用，否则本公司可立即终止向该用户提供产品和服务，并依法追究其法律责任，赔偿本公司的一切损失。
      <br />5.2 用户只有在获得本公司或其他相关权利人的授权之后才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。
      <br />5.3 用户原创作品上载、传送、输入或以其他方式提供至本软件应用时，视为用户授予本软件应用对其作品的使用权，该授权无地域、期限、方式限制，该授权为免费授权，本软件应用可在现行法律范围内就该作品进行使用，包括但不限于复制、发行、出租、展览、表演、放映、广播、信息网络传播、摄制、改编、翻译、汇编等，并可将前述权利转、分授权给其他第三方。
      <br />5.4用户在本软件上发布的信息不得侵犯任何第三人的知识产权，未经相关权利人之事先书面同意，用户不得以任何方式上传、发布、修改、传播或复制任何受著作权保护的材料、商标或属于其他人的专有信息。
      <br />
      <span>6. 隐私保护</span>
      6.1 保护用户隐私是本软件的一项基本政策，本公司保证未经用户同意不对外公开或向第三方提供用户申请资料及用户在使用本服务时存储在本软件的个人信息，但下列情况除外：
      <br />1) 事先获得用户的明确授权；
      <br />2) 根据有关的法律法规要求；
      <br />3) 按照相关政府主管部门的要求；
      <br />4) 为维护社会公众的利益；
      <br />5) 为维护本软件应用的合法权益。
      <br />6.2本软件可能会与第三方合作向用户提供相关的本服务，在此情况下，如该第三方同意承担与本公司同等的保护用户隐私的责任，则本公司可将用户的个人信息等提供给该第三方。
      <br />6.3 在不透露单个用户隐私资料的前提下，本公司有权对整个用户数据库进行分析并对用户数据库进行商业上的利用（包括但不限于公布、分析或以其它方式使用用户访问量、访问时段、用户偏好等用户数据信息）。
      <br />
      <span>7. 免责声明</span>
      7.1 对于本软件应用的产品和服务，本公司仅作下述有限保证，该有限保证取代任何文档、包装、或其他资料中的任何其他明示或默示的保证(如果有)。本公司仅以"现有状况且包含所有错误"的形式提供相关的产品、软件或程序及任何支持服务，并仅保证：
      <br />1) 本软件应用所提供的产品和服务能基本符合本软件应用正式公布的要求；
      <br />2) 本软件应用所提供的相关产品和服务基本与本软件应用正式公布的服务承诺相符；
      <br />3) 本软件应用仅在商业上允许的合理范围内尽力解决本软件应用在提供产品和服务过程中所遇到的任何问题。
      <br />7.2 在适用法律允许的最大范围内，本公司明确表示不提供任何其他类型的保证，不论是明示的或默示的，包括但不限于本软件的适销性、适用性、可靠性、准确性、完整性、无病毒以及无错误的任何明示或默示保证和责任。
      <br />7.3 在适用法律允许的最大范围内，本公司并不担保本软件所提供的产品和服务一定能满足用户的要求，也不担保提供的产品和服务不会被中断，并且对产品和服务的及时性，安全性，出错发生，以及信息是否能准确，及时，顺利的传送均不作任何担保。
      <br />7.4 在适用法律允许的最大范围内，本公司不就因用户使用本软件的产品和服务引起的，或在任何方面与本软件的产品和服务有关的任何意外的、非直接的、特殊的、或间接的损害或请求(包括但不限于因人身伤害、因隐私泄漏、因未能履行包括诚信或合理谨慎在内的任何责任、因过失和因任何其他金钱上的损失或其他损失而造成的损害赔偿)承担任何责任。
      <br />7.5本公司保留采取包括但不限于合并服务器等形式以达到服务器资源优化利用的权利，并对由此而可能导致的用户利益损失不承担责任。
      7.6 用户在本软件应用上所表达的观点、建议等内容均为用户本人看法，不代表本公司及本软件官方的观点。对于用户违法或者违反本协议的使用而引起的一切责任，由用户负全部责任，一概与本公司无关，导致本公司损失的，本公司有权要求用户赔偿，并有权立即停止向其提供服务。
      <br />7.7 用户经由本软件本服务与广告商进行通讯联系或商业往来或参与促销活动，完全属于用户与广告商之间的行为，与本公司没有任何关系，若因商业行为所产生之任何损害或损失，本公司不承担任何责任。
      <br />7.8 用户传播与复制本软件服务的内容，涉及法律规定不得传播的，由用户承担，本公司不承担任何责任。
      <br />
      <span>8. 服务变更、中断或终止</span>
      8.1软件更新
      <br />8.1.1为了改善用户体验、完善服务内容，本公司将不断努力开发新的服务，并为用户不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。
      <br />8.1.2为了保证本软件及服务的安全性和功能的一致性，本公司有权不经向用户特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。本软件新版本发布后，旧版本的软件可能无法使用。本公司不保证旧版本软件继续可用及相应的客户服务，请用户随时核对并下载最新版本。
      <br />8.2 为了软件的正常运行，本软件应用需要定期或不定期地对软件进行停机维护，因此类情况而造成的正常服务中断、停止，用户应该予以理解，本公司应尽力避免服务中断、停止或将中断、停止时间限制在最短时间内。
      <br />8.3 服务中断或终止
      <br />8.3.1如发生下列任何一种情形，本公司有权随时中断或终止向用户提供本协议项下的本服务而无需通知用户，对因此而产生的不便或损害，本公司对用户或第三人均不承担任何责任：
      <br />1) 定期检查或施工，更新软硬件等，本公司有权暂停服务，但我们会尽快完成维护、更新工作；
      <br />2) 服务器遭受损坏，无法正常运作；
      <br />3) 突发性的软硬件设备与电子通信设备故障；
      <br />4) 网络提供商线路或其它故障；
      <br />5) 在紧急情况之下为维护国家安全或其它用户及第三者之人身安全；
      <br />6) 地震、疫情等不可抗力及其他第三方原因造成服务瘫痪、中断或丢失。
      <br />8.3.2 除前款所述情形外，用户同意本公司享有通过在提前1个月（如相关法律有特别规定的且法律规定的提前通知时间超过上述期限的，以法律规定为准）网站公告通知、书面通知等方式中断或终止部分或全部本服务的权利，用户已明确知晓上述权利的授予且知晓因上述权利的行使可能给自身及其他第三方造成的直接或间接利益减损，用户在此明确表示不追究本公司因行使上述单方中断或终止服务权利而可能导致的一切责任。
      <br />
      <span>9. 违约责任</span>
      9.1 如果本公司发现用户有下列任一行为的，有权根据相应本服务的公约或守则的规定，采取相应措施：包括但不限于对该用户账号的冻结、终止、删除；用户在此承诺本公司有权作出上述行为，并承诺不就上述行为要求本公司做任何补偿或退费：
      <br />1) 用户提供虚假注册信息；
      <br />2) 用户违反本协议中规定的使用规则；
      <br />3) 通过非法手段、不正当手段或其他不公平的手段使用本软件的产品和服务或参与本软件活动；
      <br />4) 有损害本软件正当利益的行为；
      <br />5) 有严重损害其他用户的行为；
      <br />6) 有违反中华人民共和国的法律、法规的行为或言论；
      <br />7) 有违背社会风俗、社会道德和互联网一般道德和礼仪的行为；
      <br />8) 其他妨碍本软件提供产品和服务或本公司认为的严重不当行为；若有任一账号存在上述任一行为的，本公司有权对该用户下的所有账号予以制裁，包括但不限于冻结账号、删除账号、终止服务等。本公司因上述原因删除用户注册的账号后即不再对用户承担任何义务和责任。
      <br />9.2 用户同意保障和维护本软件及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给本软件或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。
      <br />
      <span>10. 修改协议</span>
      10.1本公司将可能不时的修改本协议的有关条款，一旦条款内容发生变动，本公司将会在相关的页面提示修改内容。
      <br />110.2 如果用户不同意本公司修改的内容，用户可以主动取消获得的本服务。如果用户在修改内容公告后15天内未主动取消服务，则视为接受条款的变更；修改内容公告后用户如果仍继续使用本软件提供的产品和服务亦构成对条款变更的接受。
      <br />
      <span>11. 法律管辖</span>
      11.1 本协议的订立、执行和解释及争议的解决均应适用中国法律。
      <br />11.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，用户和本公司一致同意交由软件运营商所在地有管辖权的法院管辖。
      <span>12. 通知和送达</span>
      12.1 本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该通知于发送之日视为已送达收件人。
      <span>13. 其他规定</span>
      13.1用户接受本服务条款视为用户已充分理解并同意：
      <br />1）接收本公司通过邮件、电话、短信、移动端、网页或其他合法方式，不定期发送与学习、考试资讯的相关信息；
      <br />2）接收本公司通过邮件、电话、短信、移动端、网页或其他合法方式，向用户发送的订单信息、产品或服务信息、促销活动等内容；
      <br />3）本公司依法保障用户在安装或使用过程中的知情权和选择权，在用户使用本公司服务过程中，涉及用户设备自带功能的服务会提前征得用户同意。用户一经确认，本公司有权开启包括但不限于收集地理位置、读取通讯录、使用摄像头、启用录音等提供服务必要的辅助功能。
      <br />13.2 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。
      <br />13.3 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
      <br />13.4 本协议中的标题仅为方便而设，在解释本协议时应被忽略。
      <br />
    </p>
  </div>
</template>
<script>
export default {
  name: "userNotice",
  mounted() {
    document.title = "用户协议";
  }
};
</script>
<style lang="less">
.noticePage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 10px 16px 0;
  text-align: justify;
  h4 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 25px;
    text-align: center;
    margin-bottom: 10px;
  }
  p {
    font-size: 12px;
    color: #666;
    line-height: 20px;
    span {
      display: block;
      color: #333;
      font-weight: 600;
      line-height: 25px;
    }
    padding-bottom: 10px;
  }
}
</style>